module.exports = __webpack_public_path__ + "static/home-numbers-image@2x-c2a66336ca2dbeea825e3cdf57628c6d.png";